module.exports = __webpack_public_path__ + "static/media/Knob2.73da6eee.png";